// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tags {
  position: relative;
  padding: 0.25rem 0.5rem 0 0.25rem;
  border: 1px solid rgb(234,234,234);
  border-radius: 1rem;
  background: #ffffff;
  /* shared font styles */
  font-size: 1rem;
  line-height: 1.4;
  /* clicking anywhere will focus the input */
  cursor: text;
}

.react-tags.is-active {
  border-color: #FFB600;
}

.react-tags.is-disabled {
  opacity: 0.75;
  background-color: #eaeef2;
  /* Prevent any clicking on the component */
  pointer-events: none;
  cursor: not-allowed;
}

.react-tags.is-invalid {
  border-color: #fd5956;
  box-shadow: 0 0 0 2px rgba(253, 86, 83, 0.25);
}

.react-tags__label {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  display: none;
}

.react-tags div[aria-live="polite"]{
  display: none;
}

.react-tags__list {
  /* Do not use display: contents, it's too buggy */
  display: inline;
  padding: 0;
}

.react-tags__list-item {
  display: inline;
  list-style: none;
}

.react-tags__tag {
  max-width: 100%;
  margin: 0 0.25rem 0.25rem 0;
  padding: 0.375rem 0.5rem;
  border: 0;
  border-radius: 3px;
  background: #eaeef2;
  /* match the font styles */
  font-size: inherit;
  line-height: inherit;
}

.react-tags__tag  .react-tags__tag-name{
  word-break: break-word;
}

.react-tags__tag:hover {
  color: #ffffff;
  background-color: #4f46e5;
}

.react-tags__tag::after {
  content: '';
  display: inline-block;
  width: 0.65rem;
  height: 0.65rem;
  clip-path: polygon(10% 0, 0 10%, 40% 50%, 0 90%, 10% 100%, 50% 60%, 90% 100%, 100% 90%, 60% 50%, 100% 10%, 90% 0, 50% 40%);
  margin-left: 0.5rem;
  font-size: 0.875rem;
  background-color: #7c7d86;
}

.react-tags__tag:hover::after {
  background-color: #ffffff;
}

.react-tags__combobox {
  display: inline-block;
  /* match tag layout */
  padding: 0.375rem 0.25rem;
  margin-bottom: 0.25rem;
  /* prevents autoresize overflowing the container */
  max-width: 100%;
}

.react-tags__combobox-input {
  /* prevent autoresize overflowing the container */
  min-width: 150px;
  max-width: 100%;
  /* remove styles and layout from this element */
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: none;
  /* match the font styles */
  font-size: inherit;
  line-height: inherit;
}

.react-tags__combobox-input::placeholder {
  color: #CBC3E0;
  opacity: 1;
  font-size: 0.875rem;
}

.react-tags__listbox {
  position: absolute;
  z-index: 1;
  top: calc(100% + 5px);
  /* Negate the border width on the container */
  left: -2px;
  right: -2px;
  max-height: 12.5rem;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #afb8c1;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 10px 15px -4px, rgba(0, 0, 0, 0.05) 0 4px 6px -2px;
}

.react-tags__listbox-option {
  padding: 0.375rem 0.5rem;
}

.react-tags__listbox-option:hover {
  cursor: pointer;
  background: #eaeef2;
}

.react-tags__listbox-option:not([aria-disabled='true']).is-active {
  background: #4f46e5;
  color: #ffffff;
}

.react-tags__listbox-option[aria-disabled='true'] {
  color: #7c7d86;
  cursor: not-allowed;
  pointer-events: none;
}

.react-tags__listbox-option[aria-selected='true']::after {
  content: '✓';
  margin-left: 0.5rem;
}

.react-tags__listbox-option[aria-selected='true']:not(.is-active)::after {
  color: #4f46e5;
}

.react-tags__listbox-option-highlight {
  background-color: #ffdd00;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/tag-input-styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,0HAA0H;EAC1H,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,6CAA6C;EAC7C,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mFAAmF;AACrF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".react-tags {\n  position: relative;\n  padding: 0.25rem 0.5rem 0 0.25rem;\n  border: 1px solid rgb(234,234,234);\n  border-radius: 1rem;\n  background: #ffffff;\n  /* shared font styles */\n  font-size: 1rem;\n  line-height: 1.4;\n  /* clicking anywhere will focus the input */\n  cursor: text;\n}\n\n.react-tags.is-active {\n  border-color: #FFB600;\n}\n\n.react-tags.is-disabled {\n  opacity: 0.75;\n  background-color: #eaeef2;\n  /* Prevent any clicking on the component */\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.react-tags.is-invalid {\n  border-color: #fd5956;\n  box-shadow: 0 0 0 2px rgba(253, 86, 83, 0.25);\n}\n\n.react-tags__label {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  display: none;\n}\n\n.react-tags div[aria-live=\"polite\"]{\n  display: none;\n}\n\n.react-tags__list {\n  /* Do not use display: contents, it's too buggy */\n  display: inline;\n  padding: 0;\n}\n\n.react-tags__list-item {\n  display: inline;\n  list-style: none;\n}\n\n.react-tags__tag {\n  max-width: 100%;\n  margin: 0 0.25rem 0.25rem 0;\n  padding: 0.375rem 0.5rem;\n  border: 0;\n  border-radius: 3px;\n  background: #eaeef2;\n  /* match the font styles */\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.react-tags__tag  .react-tags__tag-name{\n  word-break: break-word;\n}\n\n.react-tags__tag:hover {\n  color: #ffffff;\n  background-color: #4f46e5;\n}\n\n.react-tags__tag::after {\n  content: '';\n  display: inline-block;\n  width: 0.65rem;\n  height: 0.65rem;\n  clip-path: polygon(10% 0, 0 10%, 40% 50%, 0 90%, 10% 100%, 50% 60%, 90% 100%, 100% 90%, 60% 50%, 100% 10%, 90% 0, 50% 40%);\n  margin-left: 0.5rem;\n  font-size: 0.875rem;\n  background-color: #7c7d86;\n}\n\n.react-tags__tag:hover::after {\n  background-color: #ffffff;\n}\n\n.react-tags__combobox {\n  display: inline-block;\n  /* match tag layout */\n  padding: 0.375rem 0.25rem;\n  margin-bottom: 0.25rem;\n  /* prevents autoresize overflowing the container */\n  max-width: 100%;\n}\n\n.react-tags__combobox-input {\n  /* prevent autoresize overflowing the container */\n  min-width: 150px;\n  max-width: 100%;\n  /* remove styles and layout from this element */\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: none;\n  background: none;\n  /* match the font styles */\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.react-tags__combobox-input::placeholder {\n  color: #CBC3E0;\n  opacity: 1;\n  font-size: 0.875rem;\n}\n\n.react-tags__listbox {\n  position: absolute;\n  z-index: 1;\n  top: calc(100% + 5px);\n  /* Negate the border width on the container */\n  left: -2px;\n  right: -2px;\n  max-height: 12.5rem;\n  overflow-y: auto;\n  background: #ffffff;\n  border: 1px solid #afb8c1;\n  border-radius: 6px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 10px 15px -4px, rgba(0, 0, 0, 0.05) 0 4px 6px -2px;\n}\n\n.react-tags__listbox-option {\n  padding: 0.375rem 0.5rem;\n}\n\n.react-tags__listbox-option:hover {\n  cursor: pointer;\n  background: #eaeef2;\n}\n\n.react-tags__listbox-option:not([aria-disabled='true']).is-active {\n  background: #4f46e5;\n  color: #ffffff;\n}\n\n.react-tags__listbox-option[aria-disabled='true'] {\n  color: #7c7d86;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.react-tags__listbox-option[aria-selected='true']::after {\n  content: '✓';\n  margin-left: 0.5rem;\n}\n\n.react-tags__listbox-option[aria-selected='true']:not(.is-active)::after {\n  color: #4f46e5;\n}\n\n.react-tags__listbox-option-highlight {\n  background-color: #ffdd00;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
